import React from 'react';
import { TextField } from '@mui/material';
import clsx from 'clsx';
import { Autocomplete } from '@mui/material';
import { CountryCode, StateCode } from 'API';
import { alphaByCountry, alphabyState } from 'shared/utilities';
import { DICTIONARY } from 'shared/constants';
import { countryCodeResolver, stateCodeResolver } from 'shared/geoResolvers';

interface Props<T> {
  className?: string;
  label?: string;
  multiple?: boolean;
  onChange: (event: any, value: any) => void;
  placeholder?: string;
  type: 'country' | 'state';
  value: T | Array<T> | null;
}

const GeoPicker: React.FC<Props<CountryCode | StateCode>> = ({
  className,
  label,
  multiple,
  onChange,
  placeholder,
  type,
  value,
}: Props<CountryCode | StateCode>) => {
  const sort = type === 'country' ? alphaByCountry : alphabyState;
  const options = type === 'country'
    ? (Object.keys(CountryCode) as Array<CountryCode>).sort(sort)
    : (Object.keys(StateCode) as Array<StateCode>).sort(sort);

  return (
    <Autocomplete
      className={clsx(className, multiple && 'autocomplete--chips')}
      sx={{ width: '100%' }}
      multiple={multiple}
      noOptionsText={DICTIONARY.NoOptions}
      options={options}
      getOptionLabel={(option) => (type === 'country'
        ? countryCodeResolver(option as CountryCode)
        : stateCodeResolver(option as StateCode))}
      onChange={onChange}
      value={value || (multiple ? [] : null)}
      renderInput={(params) => (
        <strong>
          <TextField
            {...params}
            variant="standard"
            label={label}
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password',
            }}
            placeholder={placeholder}
          />
        </strong>
      )}
      renderOption={(props, option) => (
        <li {...props}>
          {type === 'country'
            ? countryCodeResolver(option as CountryCode)
            : stateCodeResolver(option as StateCode)}
        </li>
      )}
    />
  );
};

export default GeoPicker;
